module.exports = "data:image/png;base64,UklGRgABAABXRUJQVlA4WAoAAAAQAAAAPwAAGAAAQUxQSDsAAAABH6AgbQMWdipuRAS+wDaSrTYf76EEWqUESiCmOrn8Z3qjSGlE/yeAvn/4dSdikAYi5wbtQiJ2MNj+HwBWUDggngAAADAGAJ0BKkAAGQA+kUCWR6WkIiEwGAoAsBIJZwDTRKvIx/5gDG7nzywpRCV7xlJjlsz9K1LXeUYWDwAA/rn7uf0LbtrdBDh+wvSsEnZnBqT98Ld5rckGqHP7g1g3+9+S8hb06E5ea7m7U1sq/AD4Vlj6V9fFFZTpVXQtfP1HDvJ7aL8fMlxesuFcQv6aMsrxhH45atBvNEoBl8ATYAAA"


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes/RegularNode_title_gloss.png
// module id = 12
// module chunks = 0